<template>
  <Card tag="form" class="residential-mutate-shop" @submit.prevent="$emit('submit')">
    <template #default>
      <Paywall :value="addons" items="project:shop" :action="addon">
        <template #default>
          <Loader :value="true" theme="default" />
        </template>
      </Paywall>
    </template>
  </Card>
</template>

<script>
import { i18n } from '@/i18n'
import { mapState, mapActions } from 'vuex'
import API from '@/api/Shop'

import Card from '@/components/Card'
import Pricing from '@/components/Pricing'
import { Paywall } from '@/components/Upsell'

const meta = {
  order: 4,
  id: 'shop',
  label: i18n.tc('addonShop'),
  icon: ['fal', 'shopping-cart'],
}

export { meta }
export default {
  props: {
    value: Object,
    labels: Object,
    validator: Object,
    isActive: Boolean,
  },
  watch: {
    shop: {
      handler: 'prepare',
      immediate: true,
    },
    isActive: {
      handler: 'prepare',
      immediate: true,
    },
  },
  data() {
    return {
      addonName: 'project:shop',
      addonPromise: null,
    }
  },
  computed: {
    ...mapState('Residential', {
      addons(state) {
        return this.$path('item.project.metadata.addons', state) || []
      },
      id: state => state.item.id,
      project: state => state.item.project,
      shop: state => state.item.shop,
      template: state => state.item.template,
      units(state) {
        return this.$path('item.project.metadata.limits.units', state)
      },
    }),
    ...mapState('Shop', ['promises']),
  },
  methods: {
    ...mapActions('Shop', {
      async create(dispatch) {
        if (this.shop) return this.shop

        return dispatch('mutate', { reference: { onModel: 'Residential', ref: this.id } }).then(data => {
          if (!this.$path('shop.id', this.template)) return data
          return API.mutate(
            {
              id: this.$path('shop.id', this.template),
              data: { categories: [], ids: [this.id] },
            },
            {
              transformPayload: false,
              mutation: 'ShopSync',
            },
          ).then(() => data)
        })
      },
    }),
    prepare() {
      let redirect = id => {
        this.$router.replace({ name: 'shop', params: { id } })
      }

      if (!this.isActive) return
      if (!this.addons.includes(this.addonName) || !this.id) return

      return this.create().then(({ id }) => redirect(id))
    },
    addon(addon) {
      this.addonPromise = this.$store
        .dispatch('Project/addon', {
          addon,
          state: true,
          project: this.project.id,
        })
        .then(() => this.addons.push(addon))
        .then(() => this.prepare())
    },
  },
  components: {
    Card,
    Paywall,
    Pricing,
  },
}
</script>

<style lang="scss">
.residential-mutate-shop {
  max-width: 900px;

  &__cutoff {
    background: linear-gradient(css-alpha('border-color', 0.4), css-alpha('border-color', 0)) !important;
    @include cutoff(#fff, css-alpha('border-color', 0.2));
    margin: 2rem calc(-1 * var(--card-spacing)) calc(-1 * var(--card-spacing)) calc(-1 * var(--card-spacing));
    padding: calc(var(--card-spacing) * 1.5) var(--card-spacing) var(--card-spacing);
  }
}
</style>
